module.exports = __webpack_public_path__ + "img/33_31.6987c499.png";